/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserBody } from '../models/CreateUserBody';
import type { MoveUserBody } from '../models/MoveUserBody';
import type { RestoreUserBody } from '../models/RestoreUserBody';
import type { UpdateUserBody } from '../models/UpdateUserBody';
import type { User } from '../models/User';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UsersService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns User Users
   * @throws ApiError
   */
  public searchUsers({
    brokerId,
    customerId,
    claimsAdminId,
    carrierId,
    term,
    kind,
    archived,
  }: {
    brokerId?: string,
    customerId?: string,
    claimsAdminId?: string,
    carrierId?: string,
    term?: string,
    kind?: string,
    archived?: boolean,
  }): CancelablePromise<Array<User>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/users',
      query: {
        'brokerId': brokerId,
        'customerId': customerId,
        'claimsAdminId': claimsAdminId,
        'carrierId': carrierId,
        'term': term,
        'kind': kind,
        'archived': archived,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns User User
   * @throws ApiError
   */
  public createUser({
    requestBody,
  }: {
    /**
     * The User
     */
    requestBody: CreateUserBody,
  }): CancelablePromise<User> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/core/users',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public archiveUser({
    id,
  }: {
    id: string,
  }): CancelablePromise<{
    message?: string;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/users/{id}/archive',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns User User
   * @throws ApiError
   */
  public moveUser({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The User
     */
    requestBody: MoveUserBody,
  }): CancelablePromise<User> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/users/{id}/move',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns User User
   * @throws ApiError
   */
  public restoreUser({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The User
     */
    requestBody: RestoreUserBody,
  }): CancelablePromise<User> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/users/{id}/restore',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns User User
   * @throws ApiError
   */
  public findUser({
    id,
  }: {
    id: string,
  }): CancelablePromise<User> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/users/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns User User
   * @throws ApiError
   */
  public updateUser({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The User
     */
    requestBody: UpdateUserBody,
  }): CancelablePromise<User> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/users/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

}
